<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="title-h4">실행결과</div>
    </el-row>
    <el-table-wrapper class="mr-b25" row-class-name="c-pointer" :highlight-current-row="true" :data="testResult" :columns="scriptColumns" :column-default="columnDefault" :show-custom-header="false" :show-search-tool="false" :pagination="false"  @row-click="scriptResult">
      <template slot-scope="scope" slot="changeStatusSlot">
        <span v-if="scope.row.jobStatus === '1'" class="state-normal">성공</span>
        <span v-if="scope.row.jobStatus === '0'" class="state-abnormal">실패</span>
      </template>
    </el-table-wrapper>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="title-h4">{{resultMessage}}</div>
    </el-row>
    <el-input readonly type="textarea" v-model="executeResult" :rows="20" placeholder="수행 결과"></el-input>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';

export default {
  name: 'WScriptTestResult',
  components: {
  },
  props: {
    testResult: Array,
  },
  data() {
    return {
      showSearchTool: false,
      executeResult: '',
      resultMessage: '결과 메시지',
      columnDefault,
      scriptColumns: [
        {
          prop: 'jobStatus',
          width: 60,
          label: '상태',
          scopedSlot: 'changeStatusSlot',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objName',
          label: '장비명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'jobResult',
          label: '수행결과',
          showOverflowTooltip: true,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    testResult: {
      handler() {
        if (!isNil(this.testResult) && this.testResult.length > 0) {
          this.$nextTick(() => {
            this.scriptResult(this.testResult[0]);
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    scriptResult(row) {
      this.executeResult = row.jobResult;
      this.resultMessage = `${row.objName} 결과 메시지`;
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/ScriptSettings/component/ScriptTestResult.vue